<template>
    <div class="detail-info-header">
        <div class="pc">
            <div class="price-wrap">
                <price class="price" />
            </div>
            <div class="count-info">
                <caculator v-if="!hideCalculator" class="caculator" />
                <count class="count" />
            </div>
            <hr class="line" />
            <tour-button class="button" />
        </div>
        <div class="mobile">
            <div class="top">
                <div class="left">
                    <price class="price" />
                    <caculator v-if="!hideCalculator" class="caculator" />
                </div>
                <tour-button class="button" />
            </div>
            <div class="count-info">
                <count class="count" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import price from './price.vue';
import caculator from './caculator.vue';
import count from './count.vue';
import TourButton from './tour-button.vue';

export default {
    inject: ['onFavoriteClick', 'openCaculator'],
    components: {
        price,
        count,
        caculator,
        TourButton
    },
    data: function() {
        return {};
    },
    created() {},
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "house": store => store.page?.house || {}
        }),
        ...mapState({
            "listingDetail": store => store.listingDetail,
            "pricePerMonth": store => store.pricePerMonth
        }),
        info() {
            return this.listingDetail.info || {};
        },
        soldFlag() {
            if (this.info.listingStatus == 'Sold') {
                return 'sold-detail';
            }
            return '';
        },
        showListingPrice() {
            return (
                this.house.showListingPrice && this.info.listingStatus == 'Sold'
            );
        },
        trend() {
            return (
                (
                    (Math.abs(this.info.soldPrice - this.info.price) /
                        this.info.price) *
                    100
                ).toFixed(1) + '%'
            );
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
        
        hideCalculator() {
            return (
                this.info.purchaseType == 'For Rent' ||
                this.info.statusOrigin == 'Leased'
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
@mixin calc-box {
    .icon-caculator {
        position: relative;
        top: -1px;
        color: #202437;
        &:before {
            color: #202437;
            cursor: pointer;
        }
        &.nodisclosure {
            opacity: 0.4;
            &:before {
                cursor: initial;
            }
        }
        .payment-text {
            font-size: 12px;
            color: var(--color-disable);
            margin-left: 5px;
            margin-right: 8px;
        }
    }
}
.md-detail-info.broker {
    .detail-info-header {
        margin-bottom: 20px;
        .pc {
            .count-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
            .price-wrap {
                color: var(--color-label);
                padding-bottom: 6px;
                display: flex;
                position: relative;
                .caculator {
                    height: 30px;
                    line-height: 30px;
                    margin-left: 25px;
                }
                .button {
                    width: 30%;
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
            .address {
                margin-top: 15px;
            }
            .line {
                height: 1px;
                border: none;
                border-top: 1px solid #e5e8f1;
                margin: 22px 0;
            }
            // .count {
            //     margin-top: 25px;
            // }
        }
        .mobile {
            display: none;
        }
    }
    @media (max-width: 600px) {
        .detail-info-header {
            position: relative;
            margin-bottom: 0;
            .pc {
                display: none;
            }
            .mobile {
                display: block;
                .top {
                    margin-top: 15px;
                    display: flex;
                    flex-direction: row;
                }
                .left {
                    flex-shrink: 0;
                }
                .price {
                    margin: 0;
                }
                .caculator {
                    font-size: 14px;
                    margin-top: 10px;
                }
                .button {
                    flex: 1;
                    flex-shrink: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    .save {
                        display: none;
                    }
                    .btn-item {
                        margin-left: 0;
                    }
                }
                .count-info {
                    margin-top: 0;
                    padding-bottom: 30px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                }
                .address {
                    display: block;
                    width: 100%;
                    margin-top: 20px;
                }
                .count {
                    margin-top: 15px;
                }
            }
        }
    }
}
</style>
